import React, { Fragment, useState, useContext } from 'react';
import { MdHistory } from "react-icons/md";
import Swal from 'sweetalert2';

import clienteAxios from '../../../config/axios';
import { CRMContext } from '../../context/CRMContext';
import Spinner from '../../layout/Spinner';
import TarjetaInformeSimilar from './TarjetaInformeSimilar';
import PreviewBorradorInforme from './PreviewBorradorInforme';

function AsistenteInformesSimilares({ id, onAplicarBorrador, onAplicarPlantilla }) {

    const [auth] = useContext(CRMContext);

    const [ abierto, guardarAbierto ] = useState(false);
    const [ cargando, guardarCargando ] = useState(false);
    const [ error, guardarError ] = useState('');
    const [ resultados, guardarResultados ] = useState([]);
    const [ plantillaTipo, guardarPlantillaTipo ] = useState(null);
    const [ mensajeVacio, guardarMensajeVacio ] = useState('');
    const [ preview, guardarPreview ] = useState(null);
    const [ previewAbierto, guardarPreviewAbierto ] = useState(false);
    const [ cargandoPreview, guardarCargandoPreview ] = useState(false);

    const headers = {
        Authorization: `Bearer ${auth.token}`
    };

    const buscarSimilares = async () => {
        guardarAbierto(true);
        guardarCargando(true);
        guardarError('');
        guardarPreview(null);
        guardarPreviewAbierto(false);

        try {
            const res = await clienteAxios.get(`/ih/similares/${id}`, { headers });
            guardarResultados(Array.isArray(res.data.resultados) ? res.data.resultados : []);
            guardarPlantillaTipo(res.data.plantillaTipo || null);
            guardarMensajeVacio(res.data.msg || 'No se encontraron informes similares para este equipo o falla');
        } catch (err) {
            console.log(err);
            guardarResultados([]);
            guardarPlantillaTipo(null);
            guardarError(err.response?.data?.msg || 'No se pudieron buscar informes similares. Intenta de nuevo.');
        } finally {
            guardarCargando(false);
        }
    };

    const seleccionarResultado = async (resultado) => {
        guardarCargandoPreview(true);
        try {
            const res = await clienteAxios.get(`/ih/similares/${id}/preview/${resultado.informeId}`, { headers });
            guardarPreview(res.data);
            guardarPreviewAbierto(true);
        } catch (err) {
            console.log(err);
            Swal.fire({
                type: 'error',
                title: 'Hubo un error',
                text: err.response?.data?.msg || 'No se pudo generar el borrador',
                timer: 2500
            });
        } finally {
            guardarCargandoPreview(false);
        }
    };

    const aplicarPreview = async () => {
        if (!preview) {
            return;
        }
        const aplicado = await onAplicarBorrador(preview);
        if (aplicado !== false) {
            guardarPreviewAbierto(false);
            guardarAbierto(false);
        }
    };

    const tienePlantilla = plantillaTipo
        && ( (Array.isArray(plantillaTipo.conclusion) && plantillaTipo.conclusion.length > 0)
            || (Array.isArray(plantillaTipo.recomendacion) && plantillaTipo.recomendacion.length > 0)
            || plantillaTipo.conclusion
            || plantillaTipo.recomendacion );

    return (
        <Fragment>
            <div className="similar-asistente">
                <button
                    type="button"
                    className="btn-new btn-login"
                    onClick={buscarSimilares}
                    disabled={cargando}
                >
                    <MdHistory size={22}/>
                    Autogenerar desde informe anterior
                </button>

                {
                    abierto ? (
                        <div className="similar-panel">
                            {
                                cargando ? (
                                    <Spinner/>
                                ) : error ? (
                                    <div className="similar-vacio">
                                        <p>{error}</p>
                                        <button type="button" className="btn-new btn-success-new" onClick={buscarSimilares}>
                                            Reintentar
                                        </button>
                                    </div>
                                ) : resultados.length > 0 ? (
                                    <div className="similar-lista">
                                        {resultados.map((resultado) => (
                                            <TarjetaInformeSimilar
                                                key={resultado.informeId}
                                                resultado={resultado}
                                                onSeleccionar={seleccionarResultado}
                                                cargando={cargandoPreview}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="similar-vacio">
                                        <p>{mensajeVacio}</p>
                                        {
                                            tienePlantilla ? (
                                                <button
                                                    type="button"
                                                    className="btn-new btn-return"
                                                    onClick={() => onAplicarPlantilla(plantillaTipo)}
                                                >
                                                    Usar plantilla del tipo de equipo
                                                </button>
                                            ) : null
                                        }
                                    </div>
                                )
                            }
                        </div>
                    ) : null
                }
            </div>

            <PreviewBorradorInforme
                preview={preview}
                abierto={previewAbierto}
                onCerrar={() => guardarPreviewAbierto(false)}
                onAplicar={aplicarPreview}
                cargando={cargandoPreview}
            />
        </Fragment>
    )
}

export default AsistenteInformesSimilares;
